import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=f6da6a0c&"
import script from "./moreInfo.vue?vue&type=script&lang=js&"
export * from "./moreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports